<template>
  <div>

      <div class="form-group">
        <h5>記入内容に間違いがなければ送信ボタンを押してください。</h5>

        <div class="control">
          <label for="myname">氏名</label>
          <div class="textbox">{{ formData.name }}</div>
        </div>

        <div class="control">
          <label for="belong">所属</label>
          <div class="textbox">{{ formData.belong }}</div>
        </div>

        <div class="control">
          <label for="position">身分</label>
          <div class="textbox">{{ formData.position }}</div>
        </div>

        <div class="control">
          <label for="mymail">メールアドレス</label>
          <div class="textbox">{{ formData.email }}</div>
        </div>

        <div class="control">
          <label>ワークショップ参加予定（複数回答可）</label>
          <div class="checkbox">
            <label class="checkbox-inline"><input type="checkbox" v-model="formData.participation" value="1" disabled=true>&nbsp;1日目</label>
            <label class="checkbox-inline"><input type="checkbox" v-model="formData.participation" value="2" disabled=true>&nbsp;2日目</label>
            <label class="checkbox-inline"><input type="checkbox" v-model="formData.participation" value="3" disabled=true>&nbsp;3日目</label>
          </div>
        </div>

        <!-- 講演者決定のため不要 -->
        <!-- <div class="control">
          <label>講演希望</label>
          <div class="checkbox">
            <label class="checkbox-inline"><input type="checkbox" v-model="formData.talk.do" disabled=true>&nbsp;希望します</label>
          </div>
          <label style="margin-left:20px;">講演タイトル
          <span class="textbox">{{ formData.talk.title }}</span></label>
        </div> -->

        <div class="control">
          <label>懇親会参加予定</label>
          <div class="checkbox">
            <label class="checkbox-inline"><input type="checkbox" v-model="formData.banquet" disabled=true>&nbsp;参加します</label>
          </div>
        </div>

        <div class="control">
          <label for="message">ご意見等</label>
          <div class="textbox">
          <p v-for="(mess, i) in formData.message" :key="i">
            {{ mess }}
          </p>
          </div>
        </div>

        <button id="btn_send" @click.self="$emit('submit')" class="btn btn-default">送信</button>
        <button id="btn_back" @click.self="$emit('close')" class="btn btn-default" style="margin-left: 4px;">戻る</button>
      </div>

  </div>
</template>

<script>
export default {
  name: 'Validation',
  props: [
    'formData'
  ]
}
</script>

<style scoped>

.textbox {
  background-color: #eee;
  border: #aaa 1px solid;
  border-radius: 4px;
  margin-left: 2px;
  min-height: 20px;
  max-height: 40px;
  overflow-y: auto;
  padding: 4px;
  width: 100%;
}
.textbox p {
  margin: 0;
}

</style>



// WEBPACK FOOTER //
// src/components/Validation.vue